export const getLinkName = (str: string) => {
  if (str?.length > 46) {
    return str.slice(0, 40) + '...' + str.slice(-6);
  } else return str;
};
